<div class="myForm">
  <div class="card">
    <h4 class="card-header">Feedback & Rating</h4>
    <div class="card-body scroll">
      <form #synopsisForm="ngForm" (ngSubmit)="submit()">
        <div class="stars">
          <ng-container *ngFor="let item of [].constructor(5); let i = index">
            <mat-icon [style.color]="i < rating ? '#3db9b0' : 'grey'" (click)="selectRating(i)">star</mat-icon>
          </ng-container>
        </div>
        <p>
          <mat-form-field appearance="outline" color="primary">
            <textarea matInput [(ngModel)]="comment" type="text" name="comment"></textarea>
          </mat-form-field>
        </p>
        <p>
          <button color="primary" class="button" [disabled]="!synopsisForm.valid || buttonClicked" type="submit"
            mat-raised-button>
            {{ buttonClicked ? "" : "Submit" }}
            <span>
              <mat-icon *ngIf="buttonClicked">
                <mat-spinner diameter="25"></mat-spinner>
              </mat-icon>
            </span>
          </button>
        </p>
      </form>
    </div>
  </div>
</div>